import React from 'react';
import {
    Header,
    Grid, Segment,
    Button,
    Icon, Form, Dropdown, Table, Popup, Loader
} from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';


// import styled, { keyframes } from 'styled-components';
// import { fadeIn } from 'react-animations';
import { Link, Redirect } from 'react-router-dom';
import moment from 'moment';


export default class ActivePollList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            donePollListSp: [],
            activePoll: [],
            loader: true
        };
        this.getDataToRender = this.getDataToRender.bind(this);
        this.getActivePoll = this.getActivePoll.bind(this);
    }

    componentDidMount() {
        axios.get('/questionnaire/answered/study-program/')
            .then(res => {
                const donePollListSp = res.data;
                this.setState({ donePollListSp });
            })
            .catch(err => {
                console.log('Failed to fetch donePollListSp.');
            });
        this.getActivePoll();
    }

    getActivePoll() {
        console.log('statusi koje dobijam kao props', this.props.statuses);
        let status = this.props.statuses.find((e) => e.key === 'active');
        localStorage.setItem('pollStatus', status.value);
        axios.get(`/questionnaire/all/${status.value}/`)
            .then(res => {
                const activePoll = res.data;
                this.setState({ activePoll, loader: false });
            })
            .catch(err => {
                this.setState({ loader: false });
                toast('Došlo je do greške. Nije moguće prikazati trenutno aktivne ankete.');
                console.log('Failed to fetch active poll.');
            });
    }

    getDataToRender() {
        if (this.state.showFiltersOnButton) {
            return this.state.filterData;
        }
        return this.state.activePoll;
    }

    render() {
        // const FadeIn = styled.div`animation: 1s ${keyframes`${fadeIn}`}`;
        if (this.state.academicStaffEvaluation) return <Redirect push to={{ pathname: '/anketa/predmeti' }} />;
        if (this.state.studyProgramEvaluation) return <Redirect push to={{ pathname: `/anketa-sp/${JSON.parse(localStorage.getItem('poll')).pollName}` }} />;
        return (

            <div>


                {this.state.loader ? <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader size="medium" active /></div> : this.getDataToRender().length ? <Table celled selectable compact>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell >
                                Naziv
                            </Table.HeaderCell>
                            <Table.HeaderCell >
                                Tip
                            </Table.HeaderCell>
                            <Table.HeaderCell >
                                Datum objave
                            </Table.HeaderCell>
                            <Table.HeaderCell >
                                Datum isteka
                            </Table.HeaderCell>

                            <Table.HeaderCell colSpan="1" ></Table.HeaderCell>


                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {this.getDataToRender().map((el, index) =>
                            (<Table.Row
                                key={el.id}
                                positive={this.state.donePollListSp.filter((e) => e.id === el.id).length !== 0}
                            >
                                <Table.Cell verticalAlign="middle" >
                                    {el.name}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" >
                                    {el.questionnaireType.name}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" >
                                    {moment(el.activationDate).format('D. M. YYYY.')}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" >
                                    {moment(el.endDate).format('D. M. YYYY.')}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" textAlign="center" colSpan="1">
                                    {/* link */}
                                    <Link to={{ pathname: '/ankete/detalji' }}>
                                        {!this.props.showCourse && <Popup
                                            content="Detalji ankete"
                                            position="top center"
                                            trigger={
                                                <span><Button
                                                    basic="true"
                                                    circular
                                                    icon="align justify"
                                                    size="small"
                                                    color="blue"
                                                    onClick={() => { // seta se flag da se moze editovati
                                                        let poll = {
                                                            pollId: el.id,
                                                            pollName: el.name,
                                                            pollType: el.questionnaireType.id,
                                                            pollStatus: el.questionnaireStatus.id,
                                                            pollComment: el.comment,
                                                        };
                                                        localStorage.setItem('poll', JSON.stringify(poll));
                                                        localStorage.setItem('edit', 'disable');
                                                        localStorage.removeItem('delete');
                                                    }}
                                                >
                                                </Button></span>}
                                        />}
                                    </Link>

                                    { (this.props.showCourse && !(this.state.donePollListSp.filter((e) => e.id === el.id).length !== 0)) && <Button
                                        onClick={() => {
                                            let poll = {
                                                pollId: el.id,
                                                pollName: el.name,
                                                pollType: el.questionnaireType.id,
                                                pollStatus: el.questionnaireStatus.id,
                                                pollComment: el.comment,
                                                showAddQuestion: false
                                            };
                                            localStorage.setItem('poll', JSON.stringify(poll));


                                            if (el.questionnaireType._key === 'academic staff evaluation') { this.setState({ academicStaffEvaluation: true }); localStorage.setItem('academicStaffEvaluation', true); localStorage.removeItem('studyProgramEvaluation'); }
                                            if (el.questionnaireType._key === 'study program evaluation') { this.setState({ studyProgramEvaluation: true }); localStorage.setItem('studyProgramEvaluation', true); localStorage.removeItem('academicStaffEvaluation'); }
                                        }}
                                        basic="true"
                                        color="blue"
                                        size="small"
                                    > Ispuni anketu

                                    </Button> }
                                    { this.props.showCourse && this.state.donePollListSp.filter((e) => e.id === el.id).length !== 0 ? <Icon name="checkmark" /> : ''}


                                </Table.Cell>
                            </Table.Row>))}
                    </Table.Body>
                </Table> : 'Trenutno nema aktivnih anketa.'}


            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/views/Poll/AdminPoll/PollTabs/ActivePollList.js